// extracted by mini-css-extract-plugin
export var container = "style-module--container--e057f";
export var eng = "style-module--eng--1ed65";
export var highlight = "style-module--highlight--00e80";
export var how = "style-module--how--fb990";
export var rus = "style-module--rus--3de72";
export var textWrap = "style-module--text-wrap--54adb";